<template>
  <div>
    <exercise-logic
      :exCollection="$route.meta.model"
      :refCollection="$route.meta.ref"
      :saveState="saveState"
      @ready="onReady"
      @error="onError"
      @saved="onSaved"
      @savedNext="onSavedNext"
      @loadedEx="onLoadedEx"
      @loadedRefs="loadedRefs"
      :doc="doc"
      :shared="$route.meta.shared"
      :refShared="true"
    >
      <template slot-scope="{ saveExercise }">
        <v-stepper v-model="e1">
          <v-stepper-header>
            <v-stepper-step
              color="amber"
              :complete="e1 > 1"
              step="1"
              @click="e1 = 1"
              >Entities</v-stepper-step
            >
            <v-divider></v-divider>
            <v-stepper-step
              color="amber"
              :complete="e1 > 2"
              step="2"
              @click="e1 = 2"
              >Positioning</v-stepper-step
            >
            <v-divider></v-divider>
          </v-stepper-header>
          <v-stepper-items>
            <v-stepper-content step="1">
              <div class="relative">
                <v-row v-if="content">
                  <v-col cols="4" class="mb-4">
                    <h2
                      class="headline"
                      v-text="content.exercise_competition_matrix_1.step1.title"
                    ></h2>
                  </v-col>

                  <v-col cols="8" class="">
                    <p
                      v-for="(item, index) in content
                        .exercise_competition_matrix_1.step1.description"
                      :key="index"
                      v-text="item"
                    />
                  </v-col>
                </v-row>

                <v-row v-if="doc">
                  <v-col
                    :cols="getCols(columns)"
                    v-for="column in columns"
                    :key="column.model"
                  >
                    <v-card light :color="column.color">
                      <v-card-text>
                        <quadrant-items
                          v-model="doc.matrix[column.model]"
                          :name="`matrix.${column.model}`"
                          :title="column.title"
                          subtitle=""
                          :isLocked="isLocked"
                          @change="doAutoSave"
                        ></quadrant-items>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
              </div>

              <bottom-navigation
                :save="true"
                :next="true"
                :prev="false"
                :gridView="false"
                :gridToggle="false"
                @save="saveExercise(true)"
                @next="nextStep"
                @prev="prevStep"
              >
              </bottom-navigation>
            </v-stepper-content>

            <v-stepper-content step="2">
              <v-row>
                <v-col cols="12">
                  <v-select
                    :items="dropdownCategories"
                    v-model="filters"
                    item-text="title"
                    item-value="model"
                  ></v-select>
                </v-col>
                <v-col cols="2">
                  <div class="relative">
                    <div v-if="!editMode">
                      <template v-for="(item, key, index) in doc.matrix">
                        <v-list
                          dense
                          :key="`${key}-${index}`"
                          v-if="filterList(key)"
                        >
                          <v-list-item>
                            <v-list-item-title>
                              {{ getTitle(key) }}
                            </v-list-item-title>
                          </v-list-item>
                          <v-divider></v-divider>
                          <template v-for="row in item">
                            <v-list-item
                              :key="`${key}-${row.id}`"
                              @click="editItem(row, key)"
                            >
                              <v-list-item-icon>
                                <v-icon>mdi-axis-arrow</v-icon>
                              </v-list-item-icon>
                              <v-list-item-content>
                                <v-list-item-title>
                                  <div
                                    class="d-flex justify-space-between align-center"
                                  >
                                    <div>
                                      {{ row.title }}
                                      <span
                                        class="small grey--text"
                                        v-if="'scale' in row"
                                      >
                                        {{ row.scale.axis1 }} /
                                        {{ row.scale.axis2 }}
                                      </span>
                                    </div>
                                  </div>
                                  <v-btn
                                    color="white"
                                    class="mt-2"
                                    outlined
                                    light
                                    x-small
                                  >
                                    Edit
                                  </v-btn>
                                </v-list-item-title>
                              </v-list-item-content>
                            </v-list-item>
                          </template>
                          <v-divider></v-divider>
                        </v-list>
                      </template>
                    </div>
                    <CompetitionForm
                      v-if="editMode && activeModel"
                      v-model="activeModel"
                      @update="updateForm($event)"
                      @close="closeItem"
                      :axis1="axis1"
                      :axis2="axis2"
                    />
                  </div>
                </v-col>
                <v-col cols="10">
                  <div class="relative">
                    <CompetitionMatrix
                      :matrix="filteredMatrix"
                      :axis1="axis1"
                      :axis2="axis2"
                      :filter="filters"
                      :editMode="editMode"
                      :full="full"
                      @editItemMatrix="editItemMatrix"
                      :min="-10"
                      :max="-10"
                      :key="`live-matrix--${e1}`"
                      :reference="false"
                      class="fixed-top z-1"
                      name="live"
                    />
                    <CompetitionMatrix
                      :matrix="refs"
                      :axis1="axis1"
                      :axis2="axis2"
                      :editMode="editMode"
                      :full="full"
                      @editItemMatrix="editItemMatrix"
                      :min="-10"
                      :max="-10"
                      :key="`refs-matrix-${e1}`"
                      v-if="refs"
                      :reference="true"
                      class="fixed-top z-0"
                      name="refs"
                    />
                  </div>
                </v-col>
              </v-row>
              <bottom-navigation
                :save="true"
                :next="false"
                :prev="true"
                :gridView="false"
                :gridToggle="false"
                @save="saveExercise(true)"
                @prev="prevStep"
                @next="nextStep"
              >
              </bottom-navigation>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </template>
    </exercise-logic>

    <v-dialog v-model="dialog" max-width="800" v-if="content">
      <v-card v-if="dialogMode == 'save'">
        <v-card-title
          class="headline"
          v-text="content.exercise_competition_matrix_1.saved.title"
        ></v-card-title>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="amber" text @click="closeDialog">
            Close
          </v-btn>
        </v-card-actions>
      </v-card>

      <v-card v-if="dialogMode == 'add'">
        <v-card-title>Add note</v-card-title>

        <v-card-text>
          <activation-add @complete="closeDialog" />
        </v-card-text>
      </v-card>

      <v-card light v-if="dialogMode == 'show'">
        <v-card-text class="pa-10">
          <activation-show :id="cardId" @complete="closeDialog" />
        </v-card-text>
      </v-card>

      <v-card v-if="dialogMode == 'edit'">
        <v-card-title class="headline">Edit note</v-card-title>

        <v-card-text>
          <activation-edit :id="cardId" @complete="closeDialog" />
        </v-card-text>
      </v-card>

      <v-card v-else>
        <v-card-title
          class="headline"
          v-text="content.exercise_competition_matrix_1.saved.title"
        ></v-card-title>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn class="amber black--text" text @click="dialog = false">
            Close
          </v-btn>

          <v-btn color="amber accent-1 black--text" text to="/users/dashboard">
            Back to Dashboard
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapState } from 'vuex'
import { BottomNavigation } from '@/components/core'
import { ExerciseLogic } from '@/components/exercises'

import { QuadrantItems } from '@/views/user/exercises/quadrant'
import {
  CompetitionForm,
  CompetitionMatrix
} from '@/views/user/exercises/competition'

function initialState() {
  return {}
}

export default {
  name: 'UserQuadrants',
  data() {
    return {
      e1: 1,
      exercises: null,
      content: null,
      refs: null,
      dialog: false,
      dialogMode: 'add',
      allItems: null,
      listName: '',
      filters: null,
      full: false,
      results: {
        items: []
      },
      default: {
        title: 'All',
        model: null,
        color: ''
      },
      doc: {
        matrix: {}
      },
      axis1: {
        from: '',
        to: ''
      },
      axis2: {
        from: '',
        to: ''
      },
      positioning: {
        q1: [
          {
            title: 'Now',
            description: 'Where would you position yourself now?',
            scale: { axis1: 0, axis2: 0 },
            index: 0,
            id: 0,
            color: 'white',
            type: 'content'
          },
          {
            title: 'Future',
            description:
              'Where do you want to position yourself iin the future?',
            scale: { axis1: 0, axis2: 0 },
            index: 1,
            id: 1,
            color: 'white',
            type: 'content'
          }
        ]
      },
      min: -10,
      max: 10,
      list: [],
      listLength: 1,
      debug: false,
      activeModel: initialState(),
      activeList: null,
      editMode: false,
      saveState: false,
      autoSave: true
    }
  },
  components: {
    BottomNavigation,
    ExerciseLogic,
    QuadrantItems,
    CompetitionForm,
    CompetitionMatrix
  },
  computed: {
    ...mapState([
      'userProfile',
      'currentUser',
      'currentProject',
      'currentProjectModel'
    ]),
    isLocked() {
      return false
      // if (this.$route.meta.locked === true) {
      //   if (this.currentUser.uid === '4jd41CisaJZmDYMwCGMRhFclhXY2') {
      //     return false
      //   } else {
      //     return true
      //   }
      // } else {
      //   return false
      // }
    },
    col1() {
      if (this.full) {
        return '2'
      } else {
        return this.editMode ? '6' : '2'
      }
    },
    col2() {
      if (this.full) {
        return '12'
      } else {
        return this.editMode ? '6' : '10'
      }
    },
    filteredMatrix() {
      if (this.filters) {
        // console.log(this.doc.matrix[this.filters]);
        return this.doc.matrix[this.filters]
      } else {
        return this.doc.matrix
      }
    },
    dropdownCategories() {
      return [this.default, ...this.columns]
    },
    columns() {
      return this.content
        ? this.content.exercise_competition_matrix_1.step1.columns
        : null
    },
    toggleText() {
      if (this.full) {
        return 'Show Menu'
      } else {
        return 'Hide Menu'
      }
    }
  },

  async created() {
    // GET request using fetch with async/await
    const response = await fetch(`/content/${this.$route.params.id}.json`)
    const data = await response.json()

    this.content = data
    // prepopulate
    this.populateContent()
  },

  // mounted() {
  //   this.$t(`${this.$route.meta.content}.step1.columns`).forEach(item => {
  //     this.doc.matrix[item.model] = []
  //   })
  // },

  methods: {
    populateContent() {
      this.content.exercise_competition_matrix_1.step1.columns.forEach(item => {
        this.doc.matrix[item.model] = []
      })
      this.axis1 = {
        from: this.content.exercise_competition_matrix_1.axis1.from,
        to: this.content.exercise_competition_matrix_1.axis1.to
      }
      this.axis2 = {
        from: this.content.exercise_competition_matrix_1.axis2.from,
        to: this.content.exercise_competition_matrix_1.axis2.to
      }
    },
    nextStep() {
      this.e1++
    },
    prevStep() {
      this.e1--
    },
    onReady() {},
    onError() {
      console.log('error')
    },
    toggleFull() {
      this.full = !this.full
    },
    onSaved() {
      console.log('saved ex')
      this.dialogMode = ''
      this.dialog = true
    },
    onLoadedEx(items) {
      console.log('loaded exercise')
      if (items) {
        this.mergeArrays(items.doc)
      }
    },
    loadedRefs(items) {
      // console.log("items", items);
      if (items) {
        this.refs = items[0].doc.matrix
      }
    },
    onSavedNext() {
      // this.nextStep();
      console.log('autosaved')
      this.saveState = false
    },
    addIdea() {
      this.dialogMode = 'add'
      this.dialog = true
    },
    updateForm($event) {
      const item = this.activeList.find(x => x.id === $event.id)
      if (!item) return
      const index = this.activeList.indexOf(item)
      this.$set(this.activeList, index, $event)
      // this.doAutoSave();
    },
    clone(obj) {
      Object.assign({}, obj)
    },
    mergeArrays(arr) {
      // console.log("arr", arr);
      Object.entries(arr).forEach(([outerKey, value]) => {
        Object.entries(value).forEach(([key, value]) => {
          this.doc[outerKey][key] = value
        })
      })
    },
    editItem(node, list) {
      const base = {
        scale: {
          axis1: 0,
          axis2: 0
        },
        color: this.getColor(list),
        description: '',
        title: ''
      }
      this.activeModel = {
        ...base,
        ...node
      }
      this.activeList = this.doc.matrix[list]
      this.editMode = true
    },
    editItemMatrix(node) {
      const base = {
        scale: {
          axis1: 0,
          axis2: 0
        },
        color: this.getColor(node.list),
        description: '',
        title: ''
      }
      this.activeModel = {
        ...base,
        ...node
      }
      this.activeList = this.doc.matrix[node.list]
      this.editMode = true
    },
    closeItem() {
      this.activeModel = null
      this.editMode = false
      // this.doAutoSave();
    },
    filterList(key) {
      if (!this.filters) {
        return true
      }
      if (key === this.filters) {
        return true
      } else {
        return false
      }
    },
    getTitle(model) {
      if (this.columns.length) {
        const item = this.columns.find(x => x.model == model)
        if (item) {
          return item.title
        }
      }
    },
    getColor(model) {
      if (this.columns.length) {
        const item = this.columns.find(x => x.model == model)
        if (item) {
          return item.dot
        }
      }
    },
    getCols(cols) {
      let num
      switch (cols.length) {
        case 3:
          num = 4
          break
        case 4:
          num = 3
          break
        default:
          num = 4
      }
      return num
    },
    closeDialog() {
      this.dialog = false
      this.dialogMode = ''
    },
    doAutoSave() {
      if (this.autoSave) {
        console.log('doing autosave')
        this.saveState = true
      }
    }
  }
}
</script>

<style lang="scss">
.v-stepper__wrapper {
  overflow: visible;
}
.relative {
  position: relative;
  width: 100%;
  // min-height: 100vh;
  // height: 100%;
}
.fixed-top {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
}
.z-0 {
  z-index: 0;
}
.z-1 {
  z-index: 1;
}
</style>
